module.exports = __webpack_public_path__ + "static/img/测点.0d74b66.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Help/测点.gif
// module id = KVUD
// module chunks = 3